module.exports = __webpack_public_path__ + "img/58_16.9297e365.png";